import { LOGO_URL } from "@/constants";
import { Link, useLocation } from "react-router-dom";

export default function Footer() {
  const { pathname } = useLocation();
  const home = pathname === "/";
  const anchor = (id) => (home ? `#${id}` : `/#${id}`);

  return (
    <footer id="contact" className="bg-black text-white" data-testid="footer">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto py-16 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img src={LOGO_URL} alt="KERA — From God's Own Country" className="h-12 w-auto" data-testid="footer-logo" />
            <p className="mt-6 font-display font-semibold text-lg text-kera-gold max-w-sm leading-relaxed">
              KERA began with the flavours of Kerala and is creating a growing home across Europe.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-kera-gold mb-5">Explore</p>
            <ul className="space-y-3 text-sm text-white/80">
              <li><a href={anchor("story")} className="hover:text-kera-gold transition-colors" data-testid="footer-link-story">Our Story</a></li>
              <li><a href={anchor("journey")} className="hover:text-kera-gold transition-colors" data-testid="footer-link-journey">The Journey</a></li>
              <li><Link to="/products" className="hover:text-kera-gold transition-colors" data-testid="footer-link-products">The Range</Link></li>
              <li><Link to="/trade" className="hover:text-kera-gold transition-colors" data-testid="footer-link-admin">Trader Join / Login</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-kera-gold mb-5">Contact</p>
            <ul className="space-y-3 text-sm text-white/80">
              <li><a href="mailto:sales@kerafoods.eu" className="hover:text-kera-gold transition-colors" data-testid="footer-email">sales@kerafoods.eu</a></li>
              <li><a href="tel:+491782285014" className="hover:text-kera-gold transition-colors" data-testid="footer-phone">+49 178 2285014</a></li>
              <li className="text-white/60">Partnerships & distribution enquiries welcome.</li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-kera-gold/25 flex flex-col sm:flex-row justify-between gap-3">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-white/50">
            © {new Date().getFullYear()} KERA Foods
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-kera-gold/70">
            Kerala → Ireland → UK → Germany → Malta
          </p>
        </div>
      </div>
    </footer>
  );
}
